module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ad74810a8379c9515a272888211921c4.png";